import React, { useCallback, useMemo, useState } from "react";

import clock from "../../../../../styles/svg/clock.svg";
import AddWorklogCustomizedDialogs from "../addWorklog/addWorklogDialog";
import "./noWorklog.scss";
import { CustomButton } from "../../../../../components/Button/Button";

const NoWorklog = ({ cardId, premission }) => {
  const [addworklog, setAddWorklog] = useState(false);
  const isButtonDisabled = useMemo(() => !premission, [premission]);

  const handleAddWorklog = useCallback(() => {
    if (!premission) return;
    setAddWorklog(true);
  }, [premission]);

  return (
    <>
      {addworklog && (
        <AddWorklogCustomizedDialogs
          cardId={cardId}
          addWorklog={addworklog}
          setAddWorklog={setAddWorklog}
          heading={"Add Work Log"}
          buttonName={"Save"}
        />
      )}
      <div className="noWorklog">
        <img src={clock} alt="image" />
        <p>
          No Work has been logged for this issue Yet logging work lets you track
          and report on the time spent on issue.
        </p>

        <div className="noWorklog-add-worklog-btn" onClick={handleAddWorklog}>
          <CustomButton variant="contained" disabled={isButtonDisabled}>
            Add Work Log
          </CustomButton>
        </div>
      </div>
    </>
  );
};

export default React.memo(NoWorklog);
